<template>
  <div class="group-listing">
    <div class="mb-12">
      <v-row class="flex-column flex-md-row px-5">
        <v-col>
          <v-card-title
            class="display-2 letter-spacing-normal font-weight-bold px-0 px-md-3 mb-md-12 align-center"
          >
            Payment Log
          </v-card-title>
        </v-col>
        <v-col sm="12" md="4" lg="4">
          <DatePicker
            type="month"
            name="month"
            v-model="selectedMonth"
            format="MMMM YYYY"
            :display-hint="false"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            :fixed-header="false"
            class="primary-table border-radius-0 v-data-table-1 v-data-table-1--style2"
            :headers="headers"
            :items="transactions"
            :loading="model.fetching"
            loading-text="fetching data..."
            no-data-text="No data"
            no-results-text="Unable to find any data"
            :options.sync="pagination"
            :server-items-length="total"
          >
            <template v-slot:item.created_at="{ value }">
              {{ $moment(value).format('DD/MM/YY') }}
            </template>
            <template v-slot:item.amount="{ value }">
              ${{ value.currency(2) }}
            </template>
            <template v-slot:item.type="{ value }">
              {{ value === 'credit' ? 'Incoming' : 'Payout' }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Model from '@models/Transaction';

export default {
  name: 'Payments',
  components: { DatePicker: () => import('@components/utilities/DatePicker') },
  data() {
    return {
      generalHeaders: [
        {
          text: 'Name',
          value: 'subject.name',
          sortable: false,
        },
        {
          text: 'Date',
          value: 'created_at',
        },
        {
          text: 'Amount',
          value: 'amount',
          sortable: true,
        },
      ],
      pagination: {
        sortBy: ['created_at'],
        itemsPerPage: 10,
        page: 1,
        sortDesc: [true],
      },
      selectedMonth: this.$moment().format('MMMM YYYY'),
      transactions: [],
      model: new Model({
        relations: ['subject'],
        filters: {
          user_id: this.$store.state.auth.user.id,
          from: '',
          to: '',
        },
      }),
      total: 10,
    };
  },
  computed: {
    headers() {
      let headers = this.generalHeaders.slice();
      if (!this.currentUser.isTourist()) {
        headers.push({
          text: 'Type',
          value: 'type',
          sortable: false,
        });
      } else {
        headers.filter((header) => {
          if (header.value === 'amount') {
            header.text = 'Amount Paid';
          }
        });
      }
      return headers;
    },
  },
  watch: {
    pagination: {
      handler() {
        Object.assign(this.model, this.pagination);
        this.isMounted && this.fetchData();
      },
      deep: true,
      immediate: false,
    },
    selectedMonth() {
      this.fetchData();
    },
  },
  methods: {
    async fetchData() {
      Object.assign(this.model, this.pagination);
      let date = this.$moment(this.selectedMonth, 'MMMM YYYY');
      this.model.setFilters({
        from: date.format('YYYY-MM-DD'),
        to: date.endOf('month').format('YYYY-MM-DD'),
      });
      let response = await this.model.get();
      if (response) {
        this.transactions = response.data;
        this.total = response.pagination.total;
      }
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
